<template>
  <div :class="['myMedal', showHeader && 'newHomeBox']">
    <HeaderPage :isShow="showHeader" />
    <div class="mylevel">
      <img
        src="../../assets/images/medal/levelbackground.png"
        class="levelbackground"
      />
      <div class="profilepic">
        <img :src="userInfo.avatar" class="profilepicimg" />
      </div>
      <div class="usernamediv">{{ userInfo.nickname }}</div>
      <!-- <div class="follow" >+关注</div> -->
    </div>
    <div class="leveldetail" @click="openApp">
      <van-row>
        <van-col span="4"
          ><img
            style="width: 4rem; height: 4rem; margin-left: 25%"
            :src="rankIcon"
        /></van-col>
        <van-col span="7"
          ><div
            style="
              width: 10rem;
              height: 0.4rem;
              margin-top: 6.5rem;
              margin-left: 4%;
              background-image: linear-gradient(to right, #ffbbba, #fd4d4d);
              border-radius: 5px;
            "
          ></div
        ></van-col>
        <van-col span="2"
          ><img
            style="width: 2.8rem; height: 2.8rem"
            src="../../assets/images/medal/middle.png"
            alt=""
        /></van-col>
        <van-col span="7"
          ><div
            style="
              width: 10rem;
              height: 0.4rem;
              margin-top: 6.5rem;
              margin-left: 4%;
              background-image: linear-gradient(to right, #e1dfdf, #807f7f);
              border-radius: 5px;
            "
          ></div
        ></van-col>
        <van-col span="4">
          <img
            style="width: 4rem; height: 4rem"
            :src="nextRankIcon"
        /></van-col>
      </van-row>
      <div class="leftname">{{ rankTitle }}</div>
      <div class="middlename">升级还差{{ growthValue }}成长值</div>
      <div class="rightname">{{ nextRankTitle }}</div>
    </div>
    <div style="width: 100%; height: 5px; background: #f8f8f8"></div>
    <div class="medaltitle">
      <van-row>
        <van-col span="8"
          ><img
            style="width: 9.7rem; height: 0.5rem; margin-left: 1.4rem"
            src="../../assets/images/medal/medallist/leftbg.png"
            alt=""
        /></van-col>
        <van-col span="1"
          ><div style="color: #ff6f46; font-size: 2.4rem; font-weight: 900">
            {{ awardedMedalCount }}
          </div></van-col
        >
        <van-col span="1"
          ><img
            style="width: 2rem; height: 2rem"
            src="../../assets/images/medal/medallist/star.png"
        /></van-col>
        <van-col span="3"
          ><div style="color: #222222; font-size: 1.5rem; margin-top: 0.4rem">
            张勋章
          </div></van-col
        >
        <van-col span="3"
          ><div style="color: #505050; font-size: 1.4rem; margin-top: 0.4rem">
            已点亮
          </div></van-col
        >
        <van-col span="8"
          ><img
            style="width: 9.7rem; height: 0.5rem; margin-right: 1.4rem"
            src="../../assets/images/medal/medallist/rightbg.png"
            alt=""
        /></van-col>
      </van-row>
    </div>
    <div class="medalcontent">
      <div
        class="medalitem"
        v-for="(item, index) in medallist"
        v-bind:key="index"
        @click="medalhandleclick(item.detaillogo, item.level)"
      >
        <!-- <img src="../../assets/images/medal/medallist/bg.png" style="width:100%;height:100%"> -->
        <img :class="['medalitemimg', !item.time && 'grayscale']" :src="item.logo" />
        <div class="medalitemlevel">{{ item.level }}</div>
        <div v-if="item.time" class="medalitemtime">{{ timeChange(item.time) }}获取</div>
        <div v-else class="medalitemtime">待点亮</div>
      </div>
    </div>
    <van-popup v-model="show" teleport="body" class="popupdiv">
      <img :src="popupdetailimg" class="popupdetailimg" />
      <div class="popupdetaillevel">{{ popupdetaillevel }}</div>
      <img
        src="../../assets/images/medal/largemedal/close.png"
        class="popupclose"
        @click="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { getMethon } from "../../store/axiosMethon";
import Util from "../../utils/util";
import HeaderPage from "../../components/HeaderPage.vue";
import privateImg from "../../assets/images/medal/private.png";
import privateFirstImg from "../../assets/images/medal/privatefirst.png";
import { mapState } from "vuex";

export default {
  name: "medal",
  components: {
    HeaderPage,
  },
  data() {
    return {
      showHeader: true,
      userInfo: {},
      medallist: [],
      show: false,
      awardedMedalCount: "",
      popupdetaillevel: "",
      popupdetailimg: "",
      medalType: "00",
      growthValue: 0,
      rankTitle: "",
      rankIcon: "",
      nextRankTitle: "",
      nextRankIcon: "",
    };
  },
  created() {
    // jssdk初始化
    window.tem_jssdk = new window.TemplateSDK({
      switchConf: false, // 页面功能开关（点赞、评论等） 默认false：打开app；true：可以进行相关操作；json数据：控制单个功能
      imgGray: false, // 图片变灰，默认false，设置为true时全局图片置灰
      templateConf: {
        tenantId: this.mainQuery.TenantID, // 租户ID
        siteId: window.shareUlr.siteid, // 站点ID
        iosDownUrl: window.shareUlr.appDownUrl,
        androidDownUrl: window.shareUlr.appDownUrl,
        iosPKG: window.shareUlr.iosPKG,
        androidPKG: window.shareUlr.androidPKG,
        articleType: "medal", // 文稿类型
      },
    });
  },
  mounted() {
    this.showHeader = Util.showHeaderFunc();
    this.getMedalinfo();
  },
  computed: {
    ...mapState({
      mainQuery: (state) => state.mainStore.mainQuery,
    }),
  },
  methods: {
    timeChange(time) {
      let oldTime = new Date(time).getTime();
      let curTime = new Date(oldTime).format("yyyy.MM.dd");
      return curTime;
    },
    medalhandleclick(detaillogo, level) {
      this.show = true;
      this.popupdetaillevel = level;
      this.popupdetailimg = detaillogo;
    },
    follow() {
      console.log(11);
    },
    // 打开app
    openApp() {
      console.log(window.tem_jssdk, "templateSDK===================");
      // confirm(JSON.stringify(window.tem_jssdk));
      window.tem_jssdk.openApp();
    },
    getMedalinfo() {
      window.tem_jssdk.getMemberUserDetail(
        { uid: this.mainQuery.memberId, tenantid: this.mainQuery.TenantID },
        (res) => {
          if (res.code == "0000") {
            this.userInfo = res.data;
          }
        }
      );

      getMethon(
        Util.medal.getMedallevel +
          "?memberId=" +
          this.mainQuery.memberId +
          "&tenantid=" +
          this.mainQuery.TenantID,
        {},
        (res) => {
          this.growthValue = res.data.growthValue ? res.data.growthValue : 0;
          this.rankTitle = res.data.rankTitle;
          this.nextRankTitle = res.data.nextRankTitle;
          this.rankIcon = res.data.rankIcon || privateImg;
          this.nextRankIcon = res.data.nextRankIcon || privateFirstImg;
        },
        (err) => {
          console.log(err);
        }
      );

      getMethon(
        Util.medal.getMedallist +
          "?memberId=" +
          this.mainQuery.memberId +
          "&pageNumber=1&pageSize=10" +
          "&medalType=" +
          this.medalType +
          "&tenantid=" +
          this.mainQuery.TenantID,
        {},
        (res) => {
          console.log("res", res);
          this.awardedMedalCount = res.data.awardedMedalCount;
          res.data.list.forEach((element) => {
            let obj = {
              logo: element.medalIcon,
              time: element.awardDate,
              level: element.medalName,
              detaillogo: element.medalIcon,
            };
            this.medallist.push(obj);
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>


<style lang="less" scoped>
.myMedal {
  width: 100%;
  height: 100vh;

  .mylevel {
    width: 100%;
    height: 10rem;
    position: relative;

    .levelbackground {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .profilepic {
      width: 7.6rem;
      height: 7.6rem;
      position: absolute;
      top: 6.3rem;
      left: 5%;
      background-color: white;
      border-radius: 50%;
      border: 1px solid #e8e8e8;
      overflow: hidden;
      .profilepicimg {
        width: 100%;
        height: 100%;
      }
    }
    .usernamediv {
      position: absolute;
      top: 10.8rem;
      left: 29%;
      color: #222222;
      font-size: 1.8rem;
      font-weight: 900;
    }
    // .follow{
    //     position: absolute;
    //     width: 5rem;
    //     text-align: center;
    //     top:17.5rem;
    //     left:80%;
    //     background: red;
    //     color: #FFFFFF;
    //     font-weight: 900;
    //     border-radius: 1.5rem;
    // }
  }
  .leveldetail {
    margin-top: 1rem;
    width: 100%;
    height: 15.4rem;
    line-height: 15.4rem;
    position: relative;
    .leftname {
      position: absolute;
      top: 1.8rem;
      left: 6%;
    }
    .middlename {
      position: absolute;
      top: 2rem;
      left: 36%;
      font-size: 1.2rem;
      color: #999999;
    }
    .rightname {
      position: absolute;
      top: 1.8rem;
      right: 8%;
    }
  }
  .medaltitle {
    width: 100%;
    height: 3.6rem;
    margin-top: 1.5rem;
  }
  .medalcontent {
    width: 100%;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    &:after {
      content: "";
      height: 0;
      width: 25.5%;
    }
    // gap: 2rem;
    .medalitem {
      height: 12rem;
      width: 10.5rem;
      box-sizing: border-box;
      margin-top: 2rem;
      background: url("../../assets/images/medal/medallist/bg.png") no-repeat;
      background-size: 100% 100%;
      padding: 1rem 0.8rem;
      text-align: center;

      .medalitemimg {
        width: 4rem;
        height: 4rem;
      }

      .grayscale {
        filter: grayscale(1);
      }

      .medalitemlevel {
        margin: 1.2rem 0 0.4rem;
        max-height: 3.6rem;
        overflow: hidden;
        font-size: 1.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 1.8rem;
      }

      .medalitemtime {
        height: 1.6rem;
        font-size: 1.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 1.6rem;
      }
    }
  }

  .popupdiv {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0);
    text-align: center;
    .popupdetailimg {
      width: 100%;
      margin-top: 22rem;
    }
    .popupdetaillevel {
      color: #ffffff;
      width: 7.2rem;
      height: 2.5rem;
      margin-top: 1rem;
      font-size: 1.8rem;
      margin-left: 15.2rem;
    }
    .popupclose {
      margin-top: 2.7rem;
      width: 3.2rem;
      height: 3.2rem;
    }
  }
}

.newMyMedal {
  padding-top: 5.2rem;
  height: calc(100vh - 5.2rem);
}
</style>